import { OperationsActions, EOperationsActions } from "@edp-store/actions/operations.actions";
import { initialOperationsState, IOperationsState } from "@edp-store/state/operations.state";

export function operationsReducers(state = initialOperationsState, action: OperationsActions): IOperationsState {
    switch (action.type) {
        case EOperationsActions.SetOperations: {
            return {
                ...state,
                operations: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
